import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import { AlertTriangle } from "lucide-react";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-[#09090B] text-white">
      <Navbar variant="adult" />
      <div className="max-w-3xl mx-auto px-6 py-24 text-center">
        <div className="inline-flex w-14 h-14 rounded-2xl bg-amber-500/10 border border-amber-500/30 items-center justify-center mx-auto">
          <AlertTriangle className="w-6 h-6 text-amber-400" />
        </div>
        <div className="mt-6 font-adult-mono text-xs uppercase tracking-[0.28em] text-amber-400">404 · route not found</div>
        <h1 className="mt-4 font-adult-heading text-5xl md:text-6xl font-semibold tracking-tight">
          This <span className="font-adult-serif italic text-amber-400">path</span> doesn&apos;t exist.
        </h1>
        <p className="mt-4 text-zinc-400 max-w-md mx-auto">Maybe the link was old, or a lesson we&apos;ve retired. Here&apos;s where to head next:</p>
        <div className="mt-8 flex flex-wrap gap-3 justify-center">
          <Link data-testid="nf-home" to="/" className="rounded-full bg-amber-500 hover:bg-amber-400 text-black font-semibold px-6 py-3 text-sm glow-amber transition-smooth">Back to home</Link>
          <Link data-testid="nf-flagship" to="/flagship" className="rounded-full border border-zinc-800 hover:border-zinc-600 px-6 py-3 text-sm transition-smooth">Weekend Bootcamp</Link>
          <Link data-testid="nf-courses" to="/courses" className="rounded-full border border-zinc-800 hover:border-zinc-600 px-6 py-3 text-sm transition-smooth">Mini courses</Link>
        </div>
      </div>
    </div>
  );
}
